import { HeaderSimple } from "../../../pages/conversation_center/components/HeaderSimple/HeaderSimple";
import type { ColumnType } from "../columns.decl";

export const durationConfig: ColumnType = {
  id: "duration",
  label: <HeaderSimple label="duration" />,
  renderer: (_, value) => (
    <span className="block w-20 truncate text-sm">{value}</span>
  ),
};
